module.exports = __webpack_public_path__ + "static/media/plus.5fb90f7e.svg";